const PRODUCT_NAMES: Record<number, string> = {
  1: 'Hidratado',
  2: 'Outros Fins',
  3: 'Bagaço',
  4: 'Açúcar VHP',
  5: 'Anidro',
  6: 'Hidratado Consumo',
  7: 'Fertilizante',
  8: 'Oleo Fúsel',
  9: 'Anidro Outros Fins',
  10: 'Anidro Sem Corante',
};

const API_PRODUCT_CODE: Record<number, string> = {
  9400002: 'Hidratado',
  9400000: 'Etanol - Outros Fins',
  9400003: 'Anidro',
  9400004: 'Bagaço',
  9400006: 'Açúcar VHP',
  9400001: 'Hidratado Consumo',
  7000874: 'Fertilizante',
  9300000: 'Óleo Fúsel',
  9400008: 'Anidro Outros Fins',
  9400012: 'Anidro Sem Corante',
};

export const getProductNameByInternalCode = (produto: number): string => {
  return PRODUCT_NAMES[produto] ?? '';
};

export const getProductNameByApiCode = (productCode: number): string => {
  return API_PRODUCT_CODE[productCode];
};
